<template>
    <Head :title="t('connections.calendarImport.pageTitle')" />
    <BaseLayout>
        <template #header>
            <BaseLink type="button" class="flex gap-2 items-center text-ink-muted pt-4 w-fit" :href="connections_page_url">
                <i class="bi bi-chevron-left icon-bold" aria-hidden="true"></i> <span class="body-small">{{ t("connections.calendarImport.backLink") }}</span>
            </BaseLink>
        </template>
        <BasePageHeader :title="t('connections.calendarImport.title')" :subtitle="t('connections.calendarImport.subtitle')">
            <template #eyebrow>
                <div class="w-12 h-12 rounded-xl bg-surface-sunken flex items-center justify-center">
                    <i class="bi bi-calendar3 text-xl text-ink-muted" aria-hidden="true"></i>
                </div>
            </template>
        </BasePageHeader>

        <CalendarPeoplePicker
            :calendar-people-api-url="calendar_people_api_url"
            :bulk-connection-api-url="bulk_connection_api_url"
            @imported="({ created, linked }) => router.visit(`${connections_page_url}?imported=${created}&linked=${linked}`)"
            @cancel="router.visit(connections_page_url)" />
    </BaseLayout>
</template>

<script lang="ts">
import LeftSidebarLayout from "~vue/layouts/LeftSidebarLayout.vue";
export default { layout: LeftSidebarLayout };
</script>

<script setup lang="ts">
import { Head, router } from "@inertiajs/vue3";
import BaseLayout from "~vue/components/BaseLayout.vue";
import BasePageHeader from "~vue/components/BasePageHeader.vue";
import CalendarPeoplePicker from "~vue/Connections/CalendarPeoplePicker.vue";
import BaseLink from "~vue/router/BaseLink.vue";
import { useI18n } from "vue-i18n";

const { connections_page_url, calendar_people_api_url, bulk_connection_api_url } = defineProps<{
    connections_page_url: string;
    calendar_people_api_url: string;
    bulk_connection_api_url: string;
    public_profile_enabled: boolean;
    has_calendar_integration: boolean;
    event_context: Record<string, string>;
}>();

const { t } = useI18n();
</script>
